module.exports = __webpack_public_path__ + "fonts/opensans-bold.bd04b568.woff2";